import { columnPropsSchema } from '../component-catalog.js';
export const columnDefinition = {
    type: 'Column',
    category: 'layout',
    propsSchema: columnPropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    description: 'Vertical CSS Grid container. Children fill their cell by default. To override row sizing, set `tracks` — one CSS Grid track value per child. Example: `tracks: ["auto", "1fr"]` makes the first row size to content and the second fill remaining height. Other props: align?, justify?, gap? (number). For 2D tile layouts, nest Rows inside this Column.',
};
//# sourceMappingURL=Column.js.map